/**
 * Normalizes the API's loosely-typed yes/no provider flags into display text.
 *
 * Provider-level flags like `cshcsProvider` have been observed coming back in
 * several shapes depending on the plan/environment — "Y"/"N", "Yes"/"No",
 * "true"/"false", booleans, or "" when unknown. Checking only for a literal 'Y'
 * (as the CSHCS row originally did) made a provider with `cshcsProvider: "Yes"`
 * incorrectly render as "None found".
 *
 * @param {unknown} value  Raw flag value from the API.
 * @param {string}  fallback Text to show when the value is missing/unrecognized.
 * @returns {'Yes'|'No'|string}
 */
export const formatYesNo = (value, fallback = 'None found') => {
  if (value === true) return 'Yes';
  if (value === false) return 'No';
  const normalized = String(value ?? '').trim().toUpperCase();
  if (!normalized) return fallback;
  if (['Y', 'YES', 'TRUE', '1', '-1'].includes(normalized)) return 'Yes';
  if (['N', 'NO', 'FALSE', '0'].includes(normalized)) return 'No';
  return fallback;
};
